import { faEnvelope } from '@fortawesome/pro-regular-svg-icons'
import { faPhone } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Realtor } from '../../types/pages'
import { backgroundImageStyle } from '../../utils/image'
import { Button } from '../Button'
import { Link } from '../Link'

import './styles.css'

export function RealtorBox(props: Realtor) {
  return (
    <div className="realtor-container">
      {props.picture && (
        <img className="realtor-image" style={backgroundImageStyle(props.picture)} />
      )}
      <div className="realtor-box">
        <div className="mb-1">
          <div className="mb-0-5">
            <span className="tag-purple">Your realtor</span>
          </div>
          <h5 className="mb-0-5">
            {props.firstName} {props.lastName}
          </h5>
          <div>{props.brokerage}</div>
        </div>
        <div>
          {props.phoneNumber && (
            <Link to={`tel:${props.phoneNumber}`}>
              <Button theme="text">
                <FontAwesomeIcon icon={faPhone} /> {props.phoneNumber}
              </Button>
            </Link>
          )}
          {props.phoneNumber && props.emailAddress && ' | '}
          {props.emailAddress && (
            <Link to={`mailto:${props.emailAddress}`}>
              <Button theme="text">
                <FontAwesomeIcon icon={faEnvelope} /> Email {props.firstName}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
